export default __webpack_public_path__ + "static/media/flag1.483cc9bc.jpg";